document.addEventListener('DOMContentLoaded', () => {
    const $searchElements = document.querySelectorAll('.navbar-search-toggle');
    const $searchForm = document.getElementById('search-form');

    if ($searchForm && $searchElements) {
        Array.from($searchElements).forEach(($el) => {
            $el.addEventListener('click', (event) => {
                $searchForm.classList.toggle('is-active');
                document.documentElement.classList.toggle('has-search-open');

                if ($searchForm.classList.contains('is-active')) {
                    $searchForm.querySelector('input').focus();
                    $el.classList.add('is-active');
                    $el.querySelector('.search-label').innerHTML = $el.dataset.closeText;
                }
                else {
                    $el.classList.remove('is-active');
                    $el.querySelector('.search-label').innerHTML = $el.dataset.searchText;
                }
            });
        });

        document.addEventListener('click', (event) => {
            let isClickInside = false;

            if ($searchForm.contains(event.target) || Array.from($searchElements).some(element => element.contains(event.target))) {
                isClickInside = true;
            }

            if (!isClickInside) {
                $searchForm.classList.remove('is-active');
                document.documentElement.classList.remove('has-search-open');

                Array.from($searchElements).forEach(($el) => {
                    $el.classList.remove('is-active');
                    $el.querySelector('.search-label').innerHTML = $el.dataset.searchText;
                });
            }
        });
    }
});
